<template>
    <div>
        <div class="divider--container background--paper">
            <div class="divider-white--top z-10"></div>
            <div class="max-w-5xl mx-auto md:flex">
                <!-- Image -->
                <div class="divider--container w-full md:w-1/2 accountMyBoxSummary__image" :style="imageStyle">
                    <div v-if="canRate" class="divider-white--bottom block sm:hidden"></div>
                    <div v-else class="divider-paper--bottom block sm:hidden"></div>
                    <div class="divider-paper--bottom hidden sm:block md:hidden"></div>
                </div>
                <!-- Rate CTA mobile -->
                <div class="block sm:hidden">
                    <div v-if="canRate" class="bg-white">
                        <div class="accountMyBox__container text-center mx-auto px-4 pt-2 pb-4">
                            <p v-text="$t('SCHEDULE_SUMMARY_FEEDBACK')"></p>
                            <router-link class="btn btn--primary" :to="{name:'account.rate-my-flowers'}">
                                {{ $t('SCHEDULE_SUMMARY_RATE_THIS_BOX') }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <!-- Copy -->
                <div class="divider--container w-full md:w-1/2 flex items-center">
                    <div v-if="canRate" class="divider-white--top block sm:hidden"></div>
                    <div class="w-full md:w-4/5 mx-auto text-center px-4 py-12">
                        <h3 v-html="arrangementTitle"></h3>
                        <p v-html="copy"></p>
                    </div>
                </div>
            </div>
            <div class="divider-white--bottom"></div>
        </div>

        <!-- Rate CTA desktop -->
        <div class="hidden sm:block">
            <div v-if="canRate" class="bg-white">
                <div class="accountMyBox__container text-center mx-auto px-4 pt-2 pb-4">
                    <p v-text="$t('SCHEDULE_SUMMARY_FEEDBACK')"></p>
                    <router-link class="btn btn--primary" :to="{name:'account.rate-my-flowers'}">
                        {{ $t('SCHEDULE_SUMMARY_RATE_THIS_BOX') }}
                    </router-link>
                </div>
            </div>

            <div v-if="canRate" class="background--paper divider--container h-8">
                <div class="divider-white--top"></div>
                <div class="divider-white--bottom"></div>
            </div>
        </div>

        <div v-if="hasVideo" class="bg-white pt-12 text-center">
            <h2 v-text="$t('SCHEDULE_SUMMARY_ARRANGE')"></h2>
            <h3 class="mt-6" v-text="$t('SCHEDULE_SUMMARY_FOLLOW')"></h3>
        </div>

        <div v-if="hasVideo" class="background--paper divider--container flex items-center justify-center">
            <div class="divider-white--top"></div>
            <iframe :src="videoUrl" height="422" width="750" frameborder="0"></iframe>
            <div class="divider-white--bottom"></div>
        </div>

        <div class="bg-white h-8"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ScheduleSummary',
    computed: {
        ...mapGetters({
            schedule: 'cms/getActiveSchedule',
            canRate: 'cms/canRateActiveSchedule',
        }),

        imageStyle() {
            let href = this.schedule.image_url || null;

            return `background-image: url(${href})`;
        },

        arrangementTitle() {
            return this.schedule.title || '';
        },

        copy() {
            let content = this.schedule.content || '';

            return content.replace('\n', '<br /><br />');
        },

        videoUrl() {
            return this.schedule.video_url || null;
        },

        hasVideo() {
            return (this.videoUrl || '').length > 0;
        },
    },
};
</script>
